"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IInbox", {
  enumerable: true,
  get: function get() {
    return _types.IInbox;
  }
});
Object.defineProperty(exports, "useInbox", {
  enumerable: true,
  get: function get() {
    return _useInbox["default"];
  }
});

var _types = require("./types");

var _useInbox = _interopRequireDefault(require("./use-inbox"));